import maplibregl from 'maplibre-gl';
import { PMTiles, Protocol } from 'pmtiles';
import { StoryController } from './components/StoryController.js';
import { MapController } from './components/MapController.js';
import { DataProcessor } from './utils/DataProcessor.js';

class NPRStationMap {
    constructor() {
        this.storyController = null;
        this.mapController = null;
        this.dataProcessor = new DataProcessor();
        this.isLoaded = false;
        
        this.init();
    }

    async init() {
        try {
            // Show loading screen
            this.showLoading();
            
            // Initialize PMTiles protocol
            const protocol = new Protocol();
            maplibregl.addProtocol('pmtiles', protocol.tile);
            
            // Load and process data
            await this.loadData();
            
            // Initialize controllers
            this.initializeControllers();
            
            // Hide loading screen
            this.hideLoading();
            
            this.isLoaded = true;
            
        } catch (error) {
            console.error('Failed to initialize NPR Station Map:', error);
            this.showError('Failed to load station data. Please refresh to try again.');
        }
    }

    async loadData() {
        // Load NPR stations data
        await this.dataProcessor.loadStationData();
        
        // Process election results and county data
        await this.dataProcessor.processElectionData();
        
        console.log('Data loaded successfully');
    }

    initializeControllers() {
        // Initialize story controller
        this.storyController = new StoryController();
        
        // Initialize map controller with processed data
        this.mapController = new MapController({
            stationsData: this.dataProcessor.getStationsData(),
            electionData: this.dataProcessor.getElectionData(),
            onStoryChange: (panelIndex) => {
                this.storyController.showPanel(panelIndex);
            }
        });

        // Connect story and map interactions
        this.storyController.onPanelChange = (panelIndex) => {
            this.mapController.handleStoryChange(panelIndex);
        };
    }

    showLoading() {
        document.getElementById('loading-screen').classList.remove('hidden');
    }

    hideLoading() {
        setTimeout(() => {
            document.getElementById('loading-screen').classList.add('hidden');
        }, 1000);
    }

    showError(message) {
        const loadingScreen = document.getElementById('loading-screen');
        const loadingText = loadingScreen.querySelector('.loading-text');
        const progressBar = loadingScreen.querySelector('.progress-bar');
        
        loadingText.textContent = message;
        progressBar.style.display = 'none';
        
        // Add retry button
        const retryBtn = document.createElement('button');
        retryBtn.textContent = 'Retry';
        retryBtn.style.cssText = `
            margin-top: 20px;
            padding: 10px 20px;
            background: #FF6B35;
            color: white;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            font-size: 14px;
        `;
        retryBtn.onclick = () => window.location.reload();
        
        loadingScreen.querySelector('.loading-content').appendChild(retryBtn);
    }
}

// Initialize the application when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new NPRStationMap();
});

// Handle window resize
window.addEventListener('resize', () => {
    // Dispatch resize event for map
    window.dispatchEvent(new Event('mapResize'));
});
